// Docs: https://webpack.js.org/loaders/expose-loader/
import $ from "expose-loader?exposes=$,jQuery!jquery";
import Rails from "@rails/ujs";

import "bootstrap3-js/transition";
import "bootstrap3-js/modal";
import "bootstrap3-js/button";
import "bootstrap3-js/tab";
import "bootstrap3-js/tooltip";
import "bootstrap3-js/popover";
import "bootstrap3-js/dropdown";
import "bootstrap3-js/alert";
import "bootstrap3-js/collapse";
import "bootstrap-datepicker";
import moment from "moment";
import "moment/locale/pl";
import "moment/locale/ru";
import "moment/locale/ro";
import "moment/locale/cs";
import "moment/locale/hr";
import "moment/locale/sk";
import "moment/locale/de";
import "moment/locale/nl";
import "moment/locale/es";
import "moment-timezone";
import "select2";
import "jquery-minicolors";
import Xmas from "./xmas";

var defaultSelect2Options = {
  dropdownAutoWidth: true,
  allowClear: true,
};

const app = {
  initRailsUjs: function () {
    Rails.start();
  },
  initMoment: function () {
    moment.locale("pl");
  },

  initSelect2: function () {
    // Provide a getter and setter for semtree, so that we don't need to handle select2 specifics in semtree
    const makeCustomField = (el, parser = (id) => id) => {
      const field = $(el).parents("[data-field-id]")[0];
      if (!field) {
        return;
      }
      field.setAttribute("data-custom-field-type", "select2");
      field.getCustomFieldProperties = () => ({
        value: $(el).select2("val"),
      });
      field.setCustomFieldValue = (newValue) =>
        $(el).select2("val", parser(newValue));
    };
    $("[data-select2-opts]").each(function (_, elem) {
      let select2Opts = elem.dataset["select2Opts"];
      var opts = select2Opts ? JSON.parse(select2Opts) : {};
      opts = Object.assign(defaultSelect2Options, opts);
      let vals = opts.val ? opts.val : [];
      $(elem)
        .val(vals)
        .select2(opts)
        .on("select2-selected", function () {
          this.dispatchEvent(new Event("change"));
        });
      // TODO: maybe it would make sense to convert the value on output as well
      makeCustomField(elem, (value) =>
        Array.isArray(value) ? value : (value || "").split(",")
      );
    });

    // Note: automatic select2 only in ActiveAdmin filters and detail forms
    $(".filter_form select, .formtastic select").each(function (_, elem) {
      $(elem)
        .select2({
          dropdownAutoWidth: true,
          allowClear: true,
        })
        .on("select2-selected", function () {
          // Trigger event so that value change can be noticed by JS.
          //
          // TODO: theoretically select2 should already be doing this, but for
          // some reason it doesn't. Investigate.
          this.dispatchEvent(new Event("change"));
        });
      makeCustomField(elem);
    });
  },

  // TODO: possibly obsolete, I think we've switched to native datepicker in most views
  initDatepicker: function () {
    $("input.datepicker").datepicker({
      autoclose: true,
      locale: "pl",
      format: "yyyy-mm-dd",
    });
  },

  initVerifyPaymentDueDate: function () {
    $("#new_invoice_form").on("submit", function (event) {
      if (
        $("#invoice_form_payment_due_date").val() <
        $("#invoice_form_invoice_date").val()
      ) {
        var confirm_message =
          "WARNING! The payment due date is earlier than the invoice date. Please, confirm that issuing this invoice has been consulted with Accounting Department.";
        if (!confirm(confirm_message)) {
          location.reload();
          return false;
        }
      }
    });
  },

  initFetchCompanyData: function () {
    $("#js-fetch-company-data").on("click", function () {
      let vatId = $("#company_vat_id").val();
      if (!vatId) return false;
      $.post(
        "/api/v1/hq/rpc",
        JSON.stringify({
          id: "",
          method: "FetchCompanyDataRequest",
          params: { vatId: vatId },
        })
      ).then(
        function (result) {
          if (result.result) {
            const r = result.result;
            var street = r.street ? r.street : r.city;
            if (r.streetNumber) street = street + " " + r.streetNumber;
            if (r.apartmentNumber) street = street + "/" + r.apartmentNumber;
            const krsData = r.krsNumber
              ? r.krsNumber + ", " + r.krsCourt
              : null;
            $("#company_country").select2("val", "PL");
            $("#company_name").val(r.name);
            $("#company_legal_form").select2("val", r.legalForm);
            $("#company_street").val(street);
            $("#company_post_code").val(r.postcode);
            $("#company_city").val(r.city);
            $("#company_national_registry_id").val(r.regon);
            $("#company_national_registry_id_2").val(krsData);
          } else alert(JSON.stringify(result.error, null, 2));
        },
        function (error) {
          alert("Błąd wewnętrzny.");
        }
      );
      return false;
    });
  },

  initGetCompanyByVatId: function () {
    $("#company_vat_id").on("change", function () {
      let vatId = $("#company_vat_id").val().replace(/\s/g, "");
      $("#company_vat_id").val(vatId);
      $.post(
        "/api/v1/hq/rpc",
        JSON.stringify({
          id: "",
          method: "GetCompanyByVatIdRequest",
          params: { vatId },
        })
      ).then(function (result) {
        if (result.result) {
          var r = result.result;
          var message =
            "\nWpis o podanym numerze NIP już istnieje:\n\n" +
            r.name +
            ", " +
            r.street +
            ", " +
            r.postCode +
            " " +
            r.city;
          $("#company_vat_id_input")
            .addClass("has-error")
            .append(
              $("<span/>)", {
                id: "vat-id-err",
                text: message,
                class: "help-block",
              })
            );
        } else {
          $("#company_vat_id_input").removeClass("has-error");
          $("#vat-id-err").remove();
        }
      });
    });
    return false;
  },
  initGroupPromotionsForm: function () {
    var discountTypeElement = document.getElementById(
      "group_promotions_form_discount_type"
    );
    var prizeElement = document.getElementById(
      "group_promotions_form_prize_input"
    );
    var percentageElement = document.getElementById(
      "group_promotions_form_percentage_input"
    );
    function handleDiscountTypeChange() {
      if (discountTypeElement.value === "PriceDiscount") {
        prizeElement.classList.remove("hidden");
        percentageElement.classList.add("hidden");
      } else if (discountTypeElement.value === "PercentageDiscount") {
        percentageElement.classList.remove("hidden");
        prizeElement.classList.add("hidden");
      }
    }
    var addToAllElement = document.getElementById(
      "group_promotions_form_add_to_all"
    );
    var restaurantIdsElement = document.getElementById(
      "group_promotions_form_restaurant_ids_input"
    );
    function handleAddToAllChange() {
      console.log(addToAllElement.checked);
      if (addToAllElement.checked) {
        restaurantIdsElement.classList.add("hidden");
      } else {
        restaurantIdsElement.classList.remove("hidden");
      }
    }
    if (discountTypeElement) {
      handleDiscountTypeChange();
      discountTypeElement.onchange = handleDiscountTypeChange;
    }
    if (addToAllElement) {
      handleAddToAllChange();
      addToAllElement.onchange = handleAddToAllChange;
    }
  },

  initConfirmLargeAmount: function () {
    $("input[data-confirm-max]").on("change", function () {
      const limit = Number($(this).attr("data-confirm-max"));
      const amount = Number($(this).val());
      if (amount > limit && !confirm(amount.toString() + " ?")) $(this).focus();
    });
  },

  initLoginAsStaff: function () {
    $(".js-login-as-staff").on("click", function () {
      var iframeSrc = $(this).data("iframe-src");
      var token = $(this).data("login-token");
      var iframe = document.createElement("iframe");
      iframe.style = "visiblity: hidden; opacity: 0; display:inline;";
      iframe.src = iframeSrc;
      document.body.appendChild(iframe);
      var href = this.href;
      iframe.onload = function () {
        iframe.contentWindow.postMessage({ loginToken: token }, iframeSrc);
        // Race condition possible
        setTimeout(function () {
          window.location.href = href;
        }, 50);
      };
      return false;
    });
  },
  initActiveMenuRestaurantSelect: function () {
    $(".js-am-select-restaurant").on("change", function (e) {
      $(".js-am-embed-code")
        .hide()
        .filter(function (i, el) {
          return (
            el.getAttribute("data-am-embed-code") === e.currentTarget.value
          );
        })
        .show();
    });
  },

  // Handle batch actions (showing the dropdown, managing checkboxes etc), ported from ActiveAdmin
  initBatchActions: function () {
    $(".batch_actions_selector li a").off("click confirm:complete");
    $(".batch_actions_selector li a").on("click", function (event) {
      var _this = this;
      var message;
      event.stopPropagation();
      event.preventDefault();
      if ((message = $(this).data("confirm"))) {
        if (confirm(message)) {
          $(_this).trigger("confirm:complete", $(this).data("inputs"));
        }
      } else {
        $(this).trigger("confirm:complete");
      }
    });
    $(".batch_actions_selector li a").on(
      "confirm:complete",
      function (event, inputs) {
        var val;
        if ((val = JSON.stringify(inputs))) {
          $("#batch_action_inputs").removeAttr("disabled").val(val);
        } else {
          $("#batch_action_inputs").attr("disabled", "disabled");
        }
        $("#batch_action").val($(this).data("action"));
        $("#collection_selection").submit();
      }
    );
    if (
      $(".batch_actions_selector").length &&
      $(":checkbox.toggle_all").length
    ) {
      if ($(".paginated_collection table.index_table").length) {
        new TableCheckboxToggler(
          {},
          $(".paginated_collection table.index_table")
        );
      } else {
        new CheckboxToggler({}, $(".paginated_collection"));
      }
      $(document).on("change", ".paginated_collection :checkbox", function () {
        if (
          $(".paginated_collection :checkbox:checked").length &&
          $(".dropdown-menu").children().length
        ) {
          $(".batch_actions_selector > [data-toggle='dropdown']").each(
            function () {
              $(this).removeClass("disabled");
            }
          );
        } else {
          $(".batch_actions_selector > [data-toggle='dropdown']").each(
            function () {
              $(this).addClass("disabled");
            }
          );
        }
      });
    }
  },

  initForms: function () {
    $("form.formtastic[method='post']").each(function () {
      $(this).on("submit", function () {
        $(this)
          .find("input[type=submit], button[type=submit]")
          .text("Zapisuję...")
          .val("Zapisuję....");
        $(this)
          .find("input[type=submit], button[type=submit]")
          .attr("disabled", true);
      });
    });

    // This is used when removing collection elements, for example in settlement and plans forms. It's called from
    // AdminHelper::link_to_remove_fields
    function removeFields(link) {
      $(link).prev("input[type=hidden]").val("1");
      var f = $(link).closest(".fields");
      f.addClass("hide");
      f.prevAll("tr:not(.hide):first").find("input[type=text]:first").focus();
    }

    // This is used when adding collection elements, for example in settlement and plans forms. It's called from
    // AdminHelper::link_to_add_fields
    function addFields(link, association, content) {
      var new_id = new Date().getTime();
      var regexp = new RegExp("new_" + association, "g");
      var container = $($(link).data("container-id"));
      if (container.length == 0) {
        container = $(link)
          .parent(".actions")
          .prev()
          .children(".fields_container");
      }
      var fields = $(content.replace(regexp, new_id)).appendTo(container);
      app.initSelect2($("select", fields));
      $("textarea:first,input[type=text]:first", fields).first().focus();
      var e = jQuery.Event("fields_container:new_fields", { fields: fields });
      container.trigger(e);
    }

    window.Form = { removeFields, addFields };
  },

  initHeader: function () {
    Header.init();
    $(document).on(
      "updated-size.skubacz.header",
      function (e, fixedHeaderHeight) {
        // Adjust top position for elements related to sticky header
        $("#sidebar, #sidebar-2-toc, .sticky-table-header").css(
          "top",
          fixedHeaderHeight
        );
      }
    );

    $(window).on("resize", function () {
      Header.updateSize(true);
    });

    $(window).on("load", function () {
      Header.updateSize(true); // Update header size for Webpack dev env.
    });
  },

  // Ported from ActiveAdmin
  initFilters: function () {
    function queryString() {
      return (window.location.search || "").replace(/^\?/, "");
    }
    function queryStringToParams() {
      var decode = function decode(value) {
        return decodeURIComponent((value || "").replace(/\+/g, "%20"));
      };
      return queryString()
        .split("&")
        .map(function (pair) {
          return pair.split("=");
        })
        .map(function (_ref) {
          var key = _ref[0],
            value = _ref[1];
          return {
            name: decode(key),
            value: decode(value),
          };
        });
    }
    function toQueryString(params) {
      var encode = function encode(value) {
        return encodeURIComponent(value || "");
      };
      return params
        .map(function (_ref2) {
          var name = _ref2.name,
            value = _ref2.value;
          return [encode(name), encode(value)];
        })
        .map(function (pair) {
          return pair.join("=");
        })
        .join("&");
    }

    const Filters = {
      _clearForm(event) {
        var regex = /^(q\[|q%5B|q%5b|page|utf8|commit)/;
        var params = queryStringToParams().filter(function (_ref) {
          var name = _ref.name;
          return !name.match(regex);
        });
        event.preventDefault();
        window.location.search = toQueryString(params);
      },
      _disableEmptyInputFields(event) {
        var params = $(this)
          .find(":input")
          .filter(function (i, input) {
            return input.value === "";
          })
          .prop({
            disabled: true,
          })
          .end()
          .serializeArray();
      },
      _setSearchType() {
        $(this)
          .siblings("input")
          .prop({
            name: "q[" + this.value + "]",
          });
      },
    };
    $(document)
      .on("click", ".clear_filters_btn", Filters._clearForm)
      .on("submit", ".filter_form", Filters._disableEmptyInputFields)
      .on(
        "change",
        ".filter_form_field.select_and_search select",
        Filters._setSearchType
      );
  },
};

class CheckboxToggler {
  constructor(options, container) {
    this.options = options;
    this.container = container;
    this._init();
    this._bind();
  }

  _init() {
    if (!this.container) {
      throw new Error("Container element not found");
    } else {
      this.$container = $(this.container);
    }
    if (!this.$container.find(".toggle_all").length) {
      throw new Error('"toggle all" checkbox not found');
    } else {
      this.toggle_all_checkbox = this.$container.find(".toggle_all");
    }
    this.checkboxes = this.$container
      .find(":checkbox")
      .not(this.toggle_all_checkbox);
  }

  _bind() {
    var _this = this;
    this.checkboxes.change(function (event) {
      return _this._didChangeCheckbox(event.target);
    });
    this.toggle_all_checkbox.change(function () {
      return _this._didChangeToggleAllCheckbox();
    });
  }

  _didChangeCheckbox(_checkbox) {
    var numChecked = this.checkboxes.filter(":checked").length;
    var allChecked = numChecked === this.checkboxes.length;
    var someChecked = numChecked > 0 && numChecked < this.checkboxes.length;
    this.toggle_all_checkbox.prop({
      checked: allChecked,
      indeterminate: someChecked,
    });
  }

  _didChangeToggleAllCheckbox() {
    var setting = this.toggle_all_checkbox.prop("checked");
    this.checkboxes.prop({
      checked: setting,
    });
    return setting;
  }
}

class TableCheckboxToggler extends CheckboxToggler {
  _bind() {
    super._bind();
    var _this = this;
    this.$container.find("tbody td").click(function (event) {
      if (event.target.type !== "checkbox") {
        _this._didClickCell(event.target);
      }
    });
  }

  _didChangeCheckbox(checkbox) {
    super._didChangeCheckbox(checkbox);
    $(checkbox).parents("tr").toggleClass("selected", checkbox.checked);
  }

  _didChangeToggleAllCheckbox() {
    const val = super._didChangeToggleAllCheckbox();
    this.$container.find("tbody tr").toggleClass("selected", val);
  }
  _didClickCell(cell) {
    $(cell).parent("tr").find(":checkbox").click();
  }
}

var Header = (function () {
  var fixedHeaderHeight = 0;

  function init() {
    wrapHeader();
    updateSize();
  }

  function isFixed() {
    return $("#header-wrapper").css("position") === "fixed";
  }

  function adjustBody() {
    $("body").css("padding-top", fixedHeaderHeight);
  }

  function wrapHeader() {
    if (!$("#header").closest("#header-wrapper").length) {
      $("#header, #title_bar").wrapAll("<div id='header-wrapper'/>");
    }
  }

  function removeSizeUpdate() {
    $("body").css("padding-top", "");
    $("#sidebar").css("top", "");
  }

  function updateSize(checkHeaderHeight) {
    var $headerWrapper = $("#header-wrapper");
    var fixedHeaderNewHeight = $headerWrapper.height();

    if (!isFixed()) {
      fixedHeaderHeight = 0;
      removeSizeUpdate();
      return;
    }

    if (
      checkHeaderHeight === true &&
      fixedHeaderHeight === fixedHeaderNewHeight
    ) {
      return;
    }

    fixedHeaderHeight = fixedHeaderNewHeight;
    adjustBody();
    $headerWrapper.trigger("updated-size.skubacz.header", [
      fixedHeaderNewHeight,
      fixedHeaderHeight,
    ]);
  }

  return {
    init: init,
    updateSize: updateSize,
  };
})();

$(function () {
  app.initRailsUjs();
  app.initMoment();
  app.initSelect2();
  app.initDatepicker();
  app.initFetchCompanyData();
  app.initGetCompanyByVatId();
  app.initVerifyPaymentDueDate();
  app.initGroupPromotionsForm();
  app.initConfirmLargeAmount();
  app.initBatchActions();
  app.initFilters();
  app.initActiveMenuRestaurantSelect();
  app.initLoginAsStaff();
  app.initForms();
  app.initHeader();
  Xmas.init();
});
